/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '../index';

class OrgaoCentralizadoItem extends Component {
  constructor() {
    super();
    this.state = {};
  }

  buscaParticipanteRpps = () => {}

  render() {
    return (
      <div className="row" style={{ marginBottom: '10px' }}>
        <Grid cols="12 12 12 12">
          <a
            style={{ padding: '0', margin: '10px' }}
            href="#"
            onClick={() => this.props.buscaParticipanteRpps(this.props.orgao.codigo)}
          >
            {`${this.props.orgao.codigo} - ${this.props.orgao.nome} - ${this.props.orgao.extinto === 1 ? 'Extinto' : 'Ativo'}`}
          </a>
        </Grid>
      </div>
    );
  }
}

OrgaoCentralizadoItem.propTypes = {
  orgao: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.string,
    nome: PropTypes.string,
  })).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  buscaParticipanteRpps: PropTypes.func.isRequired,
};

export default OrgaoCentralizadoItem;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/OrgaosCentralizadosItem.jsx